import { nombreArchivoBoleta } from "./boletasFormat";

const CONCURRENCIA = 4;
// Pausa entre descargas sueltas: sin ella el navegador puede descartar algunas.
const PAUSA_SUELTAS_MS = 350;

const esperar = (ms) => new Promise((r) => setTimeout(r, ms));

export function dispararDescarga(url, nombre) {
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * Descarga varias boletas firmadas, en un .zip o como PDFs sueltos.
 * Reutiliza la caché del visor (lo ya visto no se vuelve a pedir al servidor).
 *
 * @returns {Promise<{ ok: object[], fallidas: {item, error}[] }>}
 */
export async function descargarEnBloque(items, { cache, modo, nombreZip, directorio, onProgress, signal }) {
  const ok = [];
  const fallidas = [];
  const archivos = {};
  let terminadas = 0;
  let colaSueltas = Promise.resolve();

  const reportar = () => onProgress?.({ terminadas, total: items.length, fallidas: fallidas.length });
  reportar();

  let siguiente = 0;
  const trabajador = async () => {
    while (siguiente < items.length) {
      if (signal?.aborted) return;
      const item = items[siguiente++];
      try {
        const objectUrl = await cache.get(item);
        if (signal?.aborted) return;
        const nombre = nombreArchivoBoleta(item);
        if (modo === "zip") {
          const buf = await (await fetch(objectUrl)).arrayBuffer();
          archivos[nombre] = new Uint8Array(buf);
        } else if (modo === "carpeta") {
          const respuesta = await fetch(objectUrl);
          if (!respuesta.ok) throw new Error("No se pudo obtener el PDF.");
          const archivo = await directorio.getFileHandle(nombre, { create: true });
          const escritura = await archivo.createWritable();
          await escritura.write(await respuesta.blob());
          await escritura.close();
        } else {
          colaSueltas = colaSueltas.then(async () => {
            if (signal?.aborted) return;
            dispararDescarga(objectUrl, nombre);
            await esperar(PAUSA_SUELTAS_MS);
          });
        }
        ok.push(item);
      } catch (error) {
        fallidas.push({ item, error });
      } finally {
        terminadas += 1;
        reportar();
      }
    }
  };

  await Promise.all(Array.from({ length: Math.min(CONCURRENCIA, items.length) }, trabajador));
  await colaSueltas;

  if (signal?.aborted) {
    throw new DOMException("Descarga cancelada", "AbortError");
  }

  if (modo === "zip" && ok.length) {
    const { zipSync } = await import("fflate");
    // level 0: los PDF ya vienen comprimidos, recomprimir solo gasta tiempo.
    const zip = zipSync(archivos, { level: 0 });
    const url = URL.createObjectURL(new Blob([zip], { type: "application/zip" }));
    dispararDescarga(url, nombreZip);
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }

  return { ok, fallidas };
}
